import Container from './Container';
import PublishDateBlock from './PublishDateBlock';
import SocialBlock from './SocialBlock';
import SocialLinks from './SocialLinks';
import Title from './Title';

type Props = {
  publishDate: string;
  title: string;
};

const TopBlock: FC<Props> = ({ publishDate, title }) => (
  <Container>
    <Title as="h1" size={48}>
      {title}
    </Title>
    <PublishDateBlock>
      <span>{publishDate}</span>
    </PublishDateBlock>
    <SocialBlock>
      <SocialLinks title={title} />
    </SocialBlock>
  </Container>
);

export default TopBlock;
